import { Filter, FilterConfig, IsFilterable } from "@/lib/filterable";
import {
  MrfiktivCustomFieldListElementViewModelGen,
  MrfiktivProjectCustomViewViewmodelGen,
  MrfiktivReportGroupConfigurationViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { CustomFieldListElement, ICustomFieldListElement } from "./custom-field-list-element.entity";
import { IProjectCustomView, ProjectCustomView } from "./project-custom-view.entity";

/**
 * Base class for report group configuration, extending project configuration.
 * Adds the 'status' property unique to report group configuration.
 */
@IsFilterable
class ReportGroupConfigurationBase {
  customFieldConfig: ICustomFieldListElement[];
  isTemplate: boolean;

  @FilterConfig({
    type: ProjectCustomView
  })
  views: IProjectCustomView[];

  @FilterConfig({ type: CustomFieldListElement })
  status?: ICustomFieldListElement | null;

  get dto() {
    return {
      isTemplate: this.isTemplate,
      views: this.views?.map(v => v.dto) ?? [],
      status: this.status
        ? {
            configuration: this.status.configuration,
            customField: this.status.customField.id
          }
        : undefined,
      customFieldConfig: this.customFieldConfig
        .filter(c => c.customField.id)
        .map(c => {
          return {
            configuration: c.configuration,
            customField: c.customField.id
          };
        })
    };
  }

  constructor(config?: Partial<ReportGroupConfigurationBase | MrfiktivReportGroupConfigurationViewModelGen>) {
    this.customFieldConfig =
      (config?.customFieldConfig as (ICustomFieldListElement | MrfiktivCustomFieldListElementViewModelGen)[])?.map(
        c => new CustomFieldListElement(c)
      ) ?? [];
    this.isTemplate = config?.isTemplate ?? false;
    this.views =
      (config?.views as (MrfiktivProjectCustomViewViewmodelGen | IProjectCustomView)[])?.map(
        (v: MrfiktivProjectCustomViewViewmodelGen | IProjectCustomView) => new ProjectCustomView(v)
      ) ?? [];
    this.status = config?.status ? new CustomFieldListElement(config.status) : undefined;
  }
}

type IReportGroupConfiguration = ReportGroupConfigurationBase;
const ReportGroupConfiguration = Filter.createForClass(ReportGroupConfigurationBase);

export { IReportGroupConfiguration, ReportGroupConfiguration };
